class ColorLinksRow {
  static SELECTORS = {
    row: '.product__color-row',
    swatch: '.block-swatch[data-color-name]',
    colorName: '.color-links__current-color',
  };

  constructor(row) {
    this._row = row;
    this._colorName = row.querySelector(ColorLinksRow.SELECTORS.colorName);
    if (!this._colorName) return;
    this._selectedColor = this._colorName.dataset.selectedColor || this._colorName.textContent.trim();
    this._abort = new AbortController();
    this._bindEvents();
  }

  _bindEvents() {
    this._row.querySelectorAll(ColorLinksRow.SELECTORS.swatch).forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        this._colorName.textContent = swatch.dataset.colorName;
      }, { signal: this._abort.signal });

      swatch.addEventListener('mouseleave', () => {
        this._colorName.textContent = this._selectedColor;
      }, { signal: this._abort.signal });
    });
  }

  destroy() { this._abort.abort(); }
}

if (window.matchMedia('(hover: hover)').matches) {
  document.querySelectorAll(ColorLinksRow.SELECTORS.row).forEach((row) => new ColorLinksRow(row));
}
